<template>
  <v-container class="text-center">
    <div class="mb-3 text-h6">Category</div>
    <v-row>
      <v-col v-for="(category, index) in categories" :key="index" cols="4">
        <task-panel
          :active="category.active"
          :label="category.label"
          :icon="category.icon"
          iconColor="#e200ff"
          @click="clickCategory($event, index)"
        />
      </v-col>
    </v-row>
    <v-divider class="my-5"></v-divider>
    <div class="mb-3 text-h6">Task</div>
    <v-row>
      <v-col v-for="(task, index) in tasks" :key="index" cols="4">
        <task-panel
          :active="task.active"
          :label="task.label"
          :icon="task.icon"
          iconColor="#00ffe2"
          @click="clickTask($event, index)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TaskPanel from "../components/TaskPanel";

export default {
  name: "Home",

  components: {
    TaskPanel,
  },
  data() {
    return {
      categories: [],
      tasks: [],
    };
  },
  methods: {
    clickTask(isOn, index) {
      try{
        window.navigator.vibrate(5);
      }
      catch{
        1;
      }
      let oldTask = this.tasks.find((x) => x.active);
      let category = this.categories.find((x) => x.active);
      let categoryLabel = category ? category.label : "";
      if (oldTask) {
        this.$store.dispatch("addEndLog");
      }
      if (isOn) {
        this.$store.dispatch("addStartLog", {
          category: categoryLabel,
          task: this.tasks[index].label,
        });
      }
      this.tasks.forEach((x) => (x.active = false));
      this.tasks[index].active = isOn;
      this.$store.dispatch("saveTasks", this.tasks);
    },
    clickCategory(isOn, index) {
      try{
        window.navigator.vibrate(5);
      }
      catch{
        1;
      }
      let nowTask = this.tasks.find((x) => x.active);
      if (nowTask) {
        this.$store.dispatch("addEndLog");
        this.$store.dispatch("addStartLog", {
          category: this.categories[index].label,
          task: nowTask.label,
        });
      }
      this.categories.forEach((x) => (x.active = false));
      this.categories[index].active = isOn;
      this.$store.dispatch("saveCategories", this.categories);
    },
  },
  created() {
    this.categories = JSON.parse(JSON.stringify(this.$store.state.categories));
    this.tasks = JSON.parse(JSON.stringify(this.$store.state.tasks));
  },
};
</script>